import axios from "axios";
import { createRoot } from "react-dom/client";
import { lazy } from "react";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes } from "react-router-dom";
import { Route } from "react-router-dom";
import { store } from "./store/configureStore";
import { Provider } from "react-redux";
import { ForgotPassword } from "./containers/ForgotPassword/ForgotPassword";
import { Login } from "./containers/Login/Login";
import { ResetPassword } from "./containers/ResetPassword/ResetPassword";
import { PrivateRoute } from "./containers/Login/PrivateRoute";
import ConnectedIntlProvider from "./ConnectedIntlProvider";
import { Signup } from "./containers/Login/Signup";
import { ToastMessage } from "./components/ToastMessage/ToastMessage";
import { ExternalPages } from "./containers/ExternalPages/ExternalPages";
import { Landing } from "./public/Landing/Landing";
import { configureAxiosClient } from "./api/axiosClient";
import AcontoSnow from "./components/AcontoSnow/AcontoSnow";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./index.css";

configureAxiosClient(axios);

// Code splitting for App
const App = lazy(() => import("./App"));

const root = createRoot(document.getElementById("root")!);
root.render(
    <Provider store={store}>
        <ConnectedIntlProvider onError={() => {}}>
            <AcontoSnow />
            <BrowserRouter>
                <Routes>
                    <Route path="/landing" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/sign-up" element={<Signup />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/external/*" element={<ExternalPages />} />

                    <Route path="/*" element={<PrivateRoute path="/" component={App} />} />
                </Routes>
                <ToastMessage />
            </BrowserRouter>
        </ConnectedIntlProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
